<script setup lang="ts">
import { PaymentsEmbed } from '@/Pejer/tables/Payments'
import { Trash2 } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'
import { Input } from 'pejer/src/components/ui/input'

import { TableCell, TableRow } from 'pejer/src/components/ui/table'
import { nextTick, ref, watch } from 'vue'

const props = defineProps<{
  moneySplit: PaymentsEmbed.MoneySplit
}>()

const emits = defineEmits<{
  (e: 'updatePayment', id: number, newAmount: number): void
}>()

// const feeSplits = props.moneySplits.filter((split) => split.isFee)
// const mainMoneySplit = props.moneySplits.find((split) => !split.isFee)

// const feeAmount = computed(() => feeSplits.reduce((acc, split) => acc + split.amount!, 0))
const grossAmount = ref<number>(props.moneySplit.amount)

function formatNumber(value: number | null) {
  if (value === null || value === undefined) {
    return ''
  }
  return value.toLocaleString('nb-no', {
    currency: 'NOK',
    style: 'currency',
    currencyDisplay: 'code',
  })
}

watch(grossAmount, (value) => {
  const clampedValue =
    value === 0 ? 0 : Math.max(Math.min(value!, props.moneySplit?.amount || 0), 0) // Math.max(, feeAmount.value + 1);

  if (value !== clampedValue && grossAmount.value !== null) {
    // Force reactivity update
    grossAmount.value = 0

    nextTick(() => {
      grossAmount.value = value === 0 ? value : clampedValue
    })
  }
  emits('updatePayment', props.moneySplit.splitID!, Math.max(clampedValue, 0))
})
</script>
<template>
  <TableRow v-if="moneySplit.isFee">
    <TableCell class="w-[10px] m-0 p-0"> </TableCell>
    <TableCell>
      <p class="text-muted-foreground my-1 text-xs text-nowrap">
        + {{ formatNumber(moneySplit.amount!) }} Avgift
      </p>
    </TableCell>
    <TableCell> </TableCell>
    <TableCell colspan="4" class="text-slate-500"> Avgifter (kan ikke justeres) </TableCell>
  </TableRow>
  <TableRow
    v-else-if="moneySplit.amount > 0"
    :class="{
      'bg-red-50': grossAmount! <= 0,
    }"
  >
    <TableCell class="w-[10px] m-0 p-0">
      <Button
        class="w-8 h-8 p-2 m-0 text-red-500 hover:bg-red-500 hover:text-white border-white border"
        :class="{
          'opacity-0 cursor-default': grossAmount === 0,
        }"
        variant="ghost"
        size="sm"
        @click="grossAmount = 0"
      >
        <Trash2 :width="8" :height="8" />
      </Button>
    </TableCell>
    <TableCell>
      <p
        class="text-muted-foreground my-2"
        :class="{
          'line-through': grossAmount !== moneySplit.amount,
        }"
      >
        {{ formatNumber(moneySplit.amount) }}
      </p>
      <p
        v-if="grossAmount !== moneySplit.amount! && grossAmount > 0"
        class="text-muted-foreground my-1 text-xs"
      >
        {{ formatNumber(grossAmount) }}
      </p>
    </TableCell>
    <TableCell>
      <div class="flex gap-2 items-center">
        <Input
          v-model="grossAmount"
          label="Beløp"
          type="number"
          placeholder="Beløp"
          class="w-[8rem]"
          :max="moneySplit.amount"
        />
        <span class="text-muted-foreground">NOK</span>
      </div>
      <p class="text-muted-foreground text-xs w-full mt-1">
        {{ formatNumber(grossAmount) }}
      </p>
    </TableCell>
    <TableCell colspan="4">
      <p class="text-muted-foreground my-2">
        {{ moneySplit.description }}
      </p>
    </TableCell>
  </TableRow>
  <TableRow v-else>
    <!-- :class="{
      'bg-red-50': grossAmount! <= 0,
    }" -->
    <TableCell></TableCell>
    <TableCell>
      <p class="text-muted-foreground my-2 text-xs">
        {{ formatNumber(moneySplit.amount) }}
      </p>
    </TableCell>
    <TableCell>
      <!-- <div class="flex gap-2 items-center">
        <Input
          v-model="grossAmount"
          label="Beløp"
          type="number"
          placeholder="Beløp"
          class="w-[8rem]"
          :max="moneySplit.amount"
        />
        <span class="text-muted-foreground">NOK</span>
      </div>
      <p class="text-muted-foreground text-xs w-full mt-1">
        {{ formatNumber(grossAmount) }}
      </p> -->
    </TableCell>
    <TableCell colspan="4">
      <p class="text-muted-foreground my-2">{{ moneySplit.description }} (kan ikke justeres)</p>
    </TableCell>
  </TableRow>
</template>
